// import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Badge from "../../../components/Badge";
import useWindowSize from "../../../hooks/useWindow";
import Layout from "../../../components/Layout";

// GET ALL ASSIGNMENT BY CLASS
const GET_ALL_ASSIGNMENT = "/api/v1/assignment/teacher";
const CLASSES_ENDPOINT = "/api/v1/teacher/classes";
const ASSIGNMENT_CONFIG_ENDPOINT = "/api/v1/assignment-configs";

const EmployeeAssignment = () => {
  const [value, setValue] = useState("1");
  const [assignmentsdata, setAssignmentsData] = useState([]);
  const [assignmentbyclass, setAssignmentByClass] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [assignmentresultbyclass, setAssignmentResultByClass] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const [isClassLoading, setIsClassLoading] = useState(false);
  const navigate = useNavigate();

  const width = useWindowSize();
  const mobile = width < 600;
  const preserveCheckboxStatus = String(currentRow?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  const getAllClasses = () => {
    setIsClassLoading(true);
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      // const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setIsClassLoading(false);
      setClassData(res?.data?.data);
    }).catch((err) => {
      setIsClassLoading(false);
      toast.error(err?.response?.data);
    });
  };

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "published"
      ? assignmentsdata?.filter((data) => data?.status === "published")
      : value === "draft"
        ? assignmentsdata?.filter((data) => data?.status === "draft")
        : value === "withdrawn"
          ? assignmentsdata?.filter((data) => data?.status === "withdrawn")
          : value === "scheduled"
            ? assignmentsdata?.filter((data) => data?.status === "scheduled")
            : value === "expired"
              ? assignmentsdata?.filter((data) => data?.status === "expired")
              : assignmentsdata;
    setSearchResult(filteredByStatus);
  };

  const handleFilterClassChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status in a class
    const filteredByStatus = value === "published"
      ? assignmentbyclass?.filter((data) => data?.status === "published")
      : value === "draft"
        ? assignmentbyclass?.filter((data) => data?.status === "draft")
        : value === "withdrawn"
          ? assignmentbyclass?.filter((data) => data?.status === "withdrawn")
          : value === "scheduled"
            ? assignmentbyclass?.filter((data) => data?.status === "scheduled")
            : value === "expired"
              ? assignmentbyclass?.filter((data) => data?.status === "expired")
              : assignmentbyclass;

    setAssignmentResultByClass(filteredByStatus);
  };

  // --| THIS IS TO GET AN ASSIGNMENT BY CLASS
  // const getAssignmentByClass = () => {
  //   setIsPageFetching(true);
  //   httprequest.get(`${ASSIGNMENT_BY_CLASS_ENDPOINT}/${value}`).then((res) => {
  //     setIsPageFetching(false);
  //     setAssignmentByClass(res?.data?.data?.assignments);
  //     setAssignmentResultByClass(res?.data?.data?.assignments);
  //   }).catch((err) => {
  //     setIsPageFetching(false);
  //     toast.error(err?.response?.data);
  //   });
  // };

  const getAllAssignment = () => {
    setIsPageFetching(true);
    httprequest.get(GET_ALL_ASSIGNMENT).then((res) => {
      setIsPageFetching(false);
      setAssignmentsData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  // Delete Assignment
  const handleDeleteAssignment = () => {
    setisDeleting(true);
    httprequest
      .delete(`${ASSIGNMENT_CONFIG_ENDPOINT}/${currentRow?.id}`, {
        data: {
          preserve_questions_in_bank: !!preserveQuestionsInBank
        }
      })
      .then((res) => {
        setisDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        getAllAssignment();
      })
      .catch((err) => {
        setisDeleting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created By</p>}
          {row?.created_by?.last_name || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Submission Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Submission Date</p>}
          {row?.submission_date?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/assignments/${row?.id}`}>
            <button className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </Link>
          <button className="table-action-icon"
            onClick={() => navigate(`/assignments/${row?.id}?editConfig`)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }

  ];

  useEffect(() => {
    getAllAssignment();
    getAllClasses();
  }, []);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const handleChange = (event, newValue) => {
    setValue(newValue);

    // Filter assignments based on the selected class
    const filteredAssignments =
      newValue === "1"
        ? assignmentsdata
        : assignmentsdata.filter((data) => data?.class?.id === newValue);

    setAssignmentResultByClass(filteredAssignments);
    setAssignmentByClass(filteredAssignments);
  };

  // --| Filter Assignment table by class using name, email and class
  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? assignmentbyclass.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : assignmentbyclass;

    // Filter by partial match in subject, class, and creator's name
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.class?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.created_by?.last_name?.toLowerCase().includes(word.toLowerCase())
    ));

    setAssignmentResultByClass(result);
  };

  // --| Filter Assignment table using name, email and class
  const handleSearchAssignment = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? assignmentsdata.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : assignmentsdata;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
            data?.class?.name?.toLowerCase()
              .includes(word.toLowerCase()) ||
            data?.created_by?.last_name?.toLowerCase()
              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // useEffect(() => {
  //   if (value !== "1") {
  //     getAssignmentByClass();
  //   }
  // }, [value]);

  return (
    <Layout children={
      <>
        <PageTitle
          title="See All Assignments For My Classes"
          subtitle="See all my assignments for the classes you teach"
          button={
            <div className="flex gap-10">
              <div className="flex gap-10">
                <Button onClick={() => {
                  navigate("/my-assignments/create-assignment");
                }} variant="primaryoutline" buttonSize="fluid" color="btnfontprimary" buttonName="Create Assignment"
                />
              </div>
            </div>
          }
        />
        <div className="page-content">
          <TabContext value={value}>
            <div className="tablist-container">
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                <Tab label="All Assignments" value="1" />
                {isClassLoading ? (
                  <div className="container-left">
                    <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
                  </div>
                ) : (
                  classesData?.map((data, i) => {
                    return (
                      <Tab key={i} value={data?.class?.id} label={data?.class?.name} />
                    );
                  })
                )}
              </Tabs>
            </div>
            <TabPanel value="1" className="tabpanel-overide">
              <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                <div className="action_div">
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignment} />
                  <div className="text-center gap-10 cursor-pointer">
                    {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                      : <Icon onClick={getAllAssignment} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                    <div>
                      <SelectGroup
                        children={
                          <select name="type" onChange={handleFilterChange}>
                            <option value="">-- Sort By--</option>
                            <option value="published">Published</option>
                            <option value="draft">Draft</option>
                            <option value="withdrawn">Withdrawn</option>
                            <option value="scheduled">Scheduled</option>
                            <option value="expired">Expired</option>
                          </select>
                        }
                      />
                    </div>
                  </div>
                </div>
              }
              />
            </TabPanel>
            {classesData?.map((data, i) => {
              return (
                <TabPanel className="tabpanel-overide" key={i} value={data?.class?.id}>
                  <Table
                    data={assignmentresultbyclass}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
                        <div className="text-center gap-10 cursor-pointer">
                          {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                            : <Icon onClick={getAllAssignment} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                          <div>
                            <SelectGroup
                              children={
                                <select name="type" onChange={handleFilterClassChange}>
                                  <option value="">-- Sort By--</option>
                                  <option value="published">Published</option>
                                  <option value="draft">Draft</option>
                                  <option value="withdrawn">Withdrawn</option>
                                  <option value="scheduled">Scheduled</option>
                                  <option value="expired">Expired</option>
                                </select>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    }
                  />
                </TabPanel>
              );
            })}

          </TabContext>
        </div>
        {/* Delete Modal */}
        <Modal
          title="Delete Assignment"
          subtitle={
            <div>
              Are you sure you want to remove{" "}
              <span className="modal-name-highlight">
                {currentRow?.title}
              </span>{" "}
              from one of your Assignment? Removing it will permanently
              clear this Assignment.
            </div>
          }
          modalContent={shouldShowPreserveQuestionsCheckbox ? (
            <div style={{ marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={preserveQuestionsInBank}
                  onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
                />
                Preserve questions on this Assignment and add them to bank.
              </label>
            </div>
          ) : <></>}
          modalFooter={
            <>
              <div className="flex gap-10">
                <Button
                  variant="dangeroutline"
                  buttonSize="full"
                  color="btndanger"
                  buttonName="Cancel"
                  onClick={handleCloseDeleteModal}
                />
                <Button
                  variant="danger"
                  buttonName="Delete Assignment"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleDeleteAssignment}
                  isLoading={isDeleting}
                />
              </div>
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default EmployeeAssignment;
